import * as React from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import NotifyHOC from '../../../../../HOC/Notifications';
import { IApplicationState } from '../../../../../reducers';
import BuilderHeader from '../../common/builderHeader';
import * as uuid from 'uuid';
import {
    MULTIMEDIA_TYPES,
    Project,
    ProjectID,
    QUOTA_STATUS,
    PROJECT_EDIT_STATUS,
    OPTION_SIZE,
    RedirectSettings
} from '@nexxt/common/types';
import { questionErrorMessage } from '../../../../../constants/applicationMessage';
import RedirectTextItem from './RedirectTextItem';
import {
    cancelEditQuestion,
    previewQuestion
} from '../../../../../services/question.service';
import * as Actions from '../../../../../actions/project.actions';
import {
    setEditedStatus,
    clearEditedStatus
} from '../../../../../services/utils.service';
import { getConfirmationBox } from '../../../../common/swal/Sweetalert';
import { alertMessage } from '../../../../../constants/alertMessage';
import { updateProject } from '../../../../../services/project.service';
import { REDIRECTS_MAPPING } from '../../../../../mapping/project';
import { createNewRichTextObject } from '@nexxt/common/services/TextService';
import ValidationService from '@nexxt/common/services/ValidationService';
import AutoSavingService from '../../../../../utils/AutoSavingService';
import HelperTooltip from '../../../../common/HelperTooltip';

interface RedirectTextProps {
    currentProject: Project;
    editEnabled: boolean;
    isEdited: boolean;
    toastNotification: any;
    editStatus: PROJECT_EDIT_STATUS;
    setProject: (project: Project) => void;
    previewQuestion: (projectId: number, questionId: number) => Promise<any>;
    setEditedStatus: (type: string, status: string) => Promise<any>;
    clearEditedStatus: (status?: PROJECT_EDIT_STATUS) => Promise<any>;
    cancelEditQuestion: () => Promise<any>;
    updateProject: (projectID: ProjectID, project: Project) => Promise<any>;
}
interface RedirectTextState {
    isSaving: boolean;
    questionLabel: string;
    redirectSettings: any;
    showError: boolean;
    errorObjects: any;
    autoSavingService: AutoSavingService<RedirectSettings>;
}

const initalRedirect = REDIRECTS_MAPPING.map((redirect) => ({
    ...redirect,
    texts: []
}));

class RedirectText extends React.Component<
    RedirectTextProps,
    RedirectTextState
> {
    private validationService;
    constructor(props) {
        super(props);
        this.validationService = new ValidationService();
        this.state = {
            isSaving: false,
            questionLabel:
                this.props.currentProject?.redirectSettings?.label || '',
            redirectSettings:
                this.props.currentProject?.redirectSettings?.redirects ||
                initalRedirect,
            showError: true,
            errorObjects: {},
            autoSavingService: new AutoSavingService(
                this.props.currentProject?.redirectSettings,
                `question|redirects`,
                false,
                this.props.editStatus,
                this.props.setEditedStatus,
                this.props.clearEditedStatus
            )
        };
    }
    componentDidMount() {
        this.state.autoSavingService.setAutoSavingInterval(this.onSave);
        this.isValid();
    }
    componentDidUpdate(
        prevProps: Readonly<RedirectTextProps>,
        prevState: Readonly<RedirectTextState>,
        snapshot?: any
    ): void {
        if (
            !_.isEqual(
                {
                    ...this.props.currentProject?.redirectSettings,
                    label: prevState.questionLabel,
                    redirects: prevState.redirectSettings
                },
                {
                    ...this.props.currentProject?.redirectSettings,
                    label: this.state.questionLabel,
                    redirects: this.state.redirectSettings
                }
            )
        ) {
            this.state.autoSavingService.setData({
                ...this.props.currentProject?.redirectSettings,
                label: this.state.questionLabel,
                redirects: this.state.redirectSettings
            });
        }

        if (!_.isEqual(prevProps.editStatus, this.props.editStatus)) {
            this.state.autoSavingService.setCurrentEditStatus(
                this.props.editStatus
            );
        }

        if (prevState.isSaving !== this.state.isSaving) {
            this.state.autoSavingService.setIsSaving(this.state.isSaving);
        }
    }
    componentWillUnmount() {
        this.state.autoSavingService &&
            this.state.autoSavingService.clearAutoSaving();
    }

    updateLabel = (questionLabel) => {
        this.setState({ questionLabel }, this.setEditFlag);
    };

    // updateURL = (type, value) => {
    //     const { redirectSettings } = this.state;

    //     const updatedRedirects = (redirectSettings as any[]).map((r) => {
    //         if (r.type === type) {
    //             return { ...r, url: value };
    //         }
    //         return r;
    //     });

    //     this.setState(
    //         {
    //             redirectSettings: updatedRedirects
    //         },
    //         this.setEditFlag
    //     );
    // };

    setQuestion = (type: QUOTA_STATUS, value) => {
        const { redirectSettings } = this.state;
        const index = redirectSettings.findIndex((r) => r.type == type);
        redirectSettings[index].multimediaTexts = value;

        this.setState(
            {
                redirectSettings
            },
            this.setEditFlag
        );
    };

    updateRedirectMessage = (
        index: number,
        value: any,
        language: string,
        textndex,
        type = MULTIMEDIA_TYPES.RICH_TEXT
    ) => {
        const { redirectSettings } = this.state;

        let currentObject = redirectSettings[index].multimediaTexts || [];
        let uploadedValue = false;
        let newTextField = currentObject.filter(
            (current) => current.language === language
        )[0];
        switch (type) {
            case MULTIMEDIA_TYPES.RICH_TEXT:
                newTextField = newTextField || {
                    language,
                    contents: [{ type, richText: {}, id: uuid.v4() }]
                };
                newTextField.contents = [
                    ...newTextField.contents.slice(0, textndex),
                    {
                        ...newTextField.contents[textndex],
                        type,
                        richText: value
                    },
                    ...newTextField.contents.slice(textndex + 1)
                ];
                break;
            case MULTIMEDIA_TYPES.IMAGE:
            case MULTIMEDIA_TYPES.VIDEO:
            case MULTIMEDIA_TYPES.AUDIO:
                newTextField.contents = [
                    ...newTextField.contents.slice(0, textndex),
                    { ...newTextField.contents[textndex], type, ...value },
                    ...newTextField.contents.slice(textndex + 1)
                ];
                break;
        }

        const currentLanguage = currentObject.map((current) => {
            if (current.language === language) {
                uploadedValue = true;

                return { ...current, contents: newTextField.contents };
            }
            return current;
        });
        if (!uploadedValue) {
            currentObject.push(newTextField);
            this.setState({ redirectSettings }, this.setEditFlag);
            return;
        }
        currentObject = [...currentLanguage];
        this.setState({ redirectSettings }, this.setEditFlag);
    };

    addNewEditor = (
        rType: QUOTA_STATUS,
        languageCode: string,
        position: number,
        type = MULTIMEDIA_TYPES.RICH_TEXT,
        data?
    ) => {
        const { redirectSettings } = this.state;

        const index = redirectSettings.findIndex((r) => r.type == rType);

        const redirects = redirectSettings;
        const languageIndex = redirects[index].multimediaTexts.findIndex(
            (text) => text.language === languageCode
        );
        let newContent;
        if (languageIndex > -1) {
            switch (type) {
                case MULTIMEDIA_TYPES.RICH_TEXT:
                    newContent = {
                        id: uuid.v4(),
                        type,
                        richText: createNewRichTextObject('')
                    };

                    break;
                case MULTIMEDIA_TYPES.IMAGE:
                case MULTIMEDIA_TYPES.VIDEO:
                case MULTIMEDIA_TYPES.AUDIO:
                    newContent = {
                        id: uuid.v4(),
                        type,
                        mediaURL: data?.mediaURL,
                        mediaOptions: { size: OPTION_SIZE.MEDIUM }
                    };
            }
            if (newContent) {
                redirects[index].multimediaTexts[languageIndex].contents = [
                    ...redirects[index].multimediaTexts[
                        languageIndex
                    ].contents.slice(0, position),
                    newContent,
                    ...redirects[index].multimediaTexts[
                        languageIndex
                    ].contents.slice(position)
                ];
            }
            this.setState(
                {
                    redirectSettings: redirects
                },
                this.setEditFlag
            );
        }
    };

    removeEditor = (
        type: QUOTA_STATUS,
        languageCode: string,
        textIndex: number
    ) => {
        const { redirectSettings } = this.state;
        const index = redirectSettings.findIndex((r) => r.type == type);

        const languageIndex = redirectSettings[index].multimediaTexts.findIndex(
            (questionText) => questionText.language === languageCode
        );

        if (languageIndex > -1) {
            redirectSettings[index].multimediaTexts[
                languageIndex
            ].contents.splice(textIndex, 1);

            this.setState(
                {
                    redirectSettings
                },
                this.setEditFlag
            );
        }
    };
    setEditFlag = () => {
        this.state.autoSavingService.setEditing();
        const isValid = this.isValid();

        this.state.autoSavingService.setEditFlag(isValid);
    };
    isValid = () => {
        let error = {
                label: '',
                redirects: []
            },
            isError = false;

        const { isEmpty, validateMultimediaTexts } = this.validationService;
        if (isEmpty(this.state.questionLabel)) {
            error = {
                ...error,
                label: questionErrorMessage.REQUIRED
            };
            isError = true;
        }
        this.state.redirectSettings.forEach((r, i) => {
            error.redirects[i] = { texts: {}, url: '' };
            const questionTextValidator = validateMultimediaTexts(
                r.multimediaTexts,
                this.props.currentProject.languages
            );
            if (questionTextValidator.isError) {
                isError = true;
                error.redirects[i].questionTexts = questionTextValidator;
            }
        });
        this.setState({ errorObjects: { isError, ...error } });
        return { isError, error };
    };

    cancelQuestion = async () => {
        if (!this.state.isSaving) {
            if (this.props.isEdited) {
                await getConfirmationBox({
                    message: alertMessage.CONFIRM_CONTINUE,
                    showCloseButton: true,
                    confirmButtonColor: '',
                    title: alertMessage.UNDO_CURRENT_CHANGE
                }).then((x) => {
                    if (!x.value) return;
                });
            }
            this.props.cancelEditQuestion();
        }
    };
    onSave = async () => {
        if (this.state.isSaving) {
            return;
        }
        const checkValidity = this.isValid(); //TODO : This validation according to this page

        if (!checkValidity.isError) {
            this.setState({
                isSaving: true
            });

            try {
                const newProjectData = {
                    ...this.props.currentProject,
                    redirectSettings: {
                        ...this.props.currentProject.redirectSettings,
                        label: this.state.questionLabel,
                        redirects: this.state.redirectSettings
                    }
                };
                await this.props.updateProject(
                    this.props.currentProject.id,
                    newProjectData
                );
                this.state.autoSavingService.setSyncedData(
                    newProjectData.redirectSettings
                );
                this.setState({ isSaving: false });
                this.props.setProject(newProjectData);
                this.props.clearEditedStatus();
            } catch (e) {
                this.setState({
                    isSaving: false
                });
                console.error(e);
                this.props.toastNotification.error(
                    alertMessage.QUESTION_FORM_INVALID
                );
            }
        } else {
            this.setState({
                showError: true,
                errorObjects: checkValidity.error
            });
            this.props.clearEditedStatus(PROJECT_EDIT_STATUS.FAILED);
        }
    };
    renderRedirects = () => {
        const { redirectSettings } = this.state;

        return (redirectSettings as any[]).map((r, i) => {
            return (
                <RedirectTextItem
                    key={r.type}
                    languages={this.props.currentProject.languages}
                    redirectSetting={r}
                    addNewEditor={(langaugeCode, position, type, data) =>
                        this.addNewEditor(
                            r.type,
                            langaugeCode,
                            position,
                            type,
                            data
                        )
                    }
                    setValue={(value) => this.setQuestion(r.type, value)}
                    removeEditor={(languageCode, textIndex) =>
                        this.removeEditor(r.type, languageCode, textIndex)
                    }
                    updateRedirectMessage={(
                        keyName,
                        value,
                        language,
                        textndex,
                        type
                    ) =>
                        this.updateRedirectMessage(
                            i,
                            value,
                            language,
                            textndex,
                            type
                        )
                    }
                    editEnabled={this.props.editEnabled}
                    errorObject={
                        this.state.showError &&
                        this.state.errorObjects?.redirects?.[i]
                    }
                />
            );
        });
    };
    render() {
        const { questionLabel } = this.state;
        return (
            <div>
                <div className="project-add--question-builder">
                    <BuilderHeader
                        isSettingBoxLayoutOpen={false}
                        showQuestionSetting={false}
                        showAlert={!this.props.editEnabled}
                        question={{ title: questionLabel || '' }}
                        setValue={(keyName, value) => this.updateLabel(value)}
                        disabled={!this.props.editEnabled}
                    />
                    <div className="builder-body">{this.renderRedirects()}</div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store: IApplicationState) => {
    const {
        projectReducer: { currentProject, editEnabled },
        utilsReducer: { isEdited, editStatus }
    } = store;

    return {
        currentProject,
        editEnabled: editEnabled['question'],
        isEdited,
        editStatus
    };
};

const mapDispatchToProps = (dispatch) => ({
    updateProject: (projectID: ProjectID, project: Project) =>
        dispatch(updateProject(projectID, project)),
    setProject: (newProject: Project) => {
        dispatch(Actions.setProject(newProject));
    },
    previewQuestion: (projectId: number, questionId: number) =>
        dispatch(previewQuestion(projectId, questionId)),
    setEditedStatus: (type: string, status: PROJECT_EDIT_STATUS) =>
        dispatch(setEditedStatus(type, status)),
    clearEditedStatus: (status?: PROJECT_EDIT_STATUS) =>
        dispatch(clearEditedStatus(status)),
    cancelEditQuestion: () => dispatch(cancelEditQuestion())
});
export default NotifyHOC(
    connect(mapStateToProps, mapDispatchToProps)(RedirectText)
);
